import {
  FieldConfig,
  FieldValidations,
} from "layouts/NewUniversalField/NewUniversalField";
import { BillerCustomerParam } from "./billerTypes";
import { isRegexEnabled } from "utils/Regexvalidationcontrol/regexControl";
import { REGEX_CONTROL } from "configs/Regexvalidationcontrol/regexControlConfig";

function toSafeId(paramName: string): string {
  return paramName
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");
}

function detectAllowedChars(dataType: string) {
  const type = dataType.toUpperCase();

  if (type === "NUMERIC") return "numeric" as const;
  if (type === "ALPHA") return "alpha" as const;
  // if (type === "ALPHANUMERIC") return "alphanumeric" as const;

  // if (regex?.includes("[0-9]") && !/[A-Za-z]/.test(regex)) return "numeric";
  // if (regex?.includes("[A-Za-z]") && !/[0-9]/.test(regex)) return "alpha";
  // if (/[0-9]/.test(regex || "") && /[A-Za-z]/.test(regex || "")) {
  //   return "alphanumeric";
  // }

  return undefined;
}

export function mapCustomerParamsToFields(
  params: BillerCustomerParam[] | undefined,
  ctx: { billerId?: string; categoryName?: string } = {},
): {
  fields: FieldConfig[];
  initialValues: Record<string, string>;
  fieldIdToParamName: Record<string, string>;
} {
  const fields: FieldConfig[] = [];
  const initialValues: Record<string, string> = {};
  const fieldIdToParamName: Record<string, string> = {};

  if (!params || params.length === 0) {
    return { fields, initialValues, fieldIdToParamName };
  }

  const applyRegex = isRegexEnabled(REGEX_CONTROL, ctx);

  for (const p of params) {
    const id = toSafeId(p.paramName);

    const required =
      typeof p.optional === "string"
        ? p.optional.toLowerCase() === "false"
        : !p.optional;

    const validations: FieldValidations = {};

    if (p.minLength) validations.minLength = Number(p.minLength);
    if (p.maxLength) validations.maxLength = Number(p.maxLength);

    // ONLY numeric/alpha input filter; ALPHANUMERIC => no filter
    const allowedChars = detectAllowedChars(p.dataType);
    if (allowedChars) validations.allowedChars = allowedChars;

    // ONLY biller regex, and only when enabled
    if (applyRegex && p.regex) {
      try {
        validations.pattern = new RegExp(p.regex);
      } catch {
        // invalid biller regex -> ignore
      }
    }

    const field: FieldConfig = {
      id,
      label: p.paramName,
      as: "input",
      type: "text",
      placeholder: p.paramName,
      required,
      validations,
      meta: { billerParamName: p.paramName },
    };

    fields.push(field);
    initialValues[id] = "";
    fieldIdToParamName[id] = p.paramName;
  }

  return { fields, initialValues, fieldIdToParamName };
}

// export function mapCustomerParamsToFields(
//   params: BillerCustomerParam[] | undefined
// ): {
//   fields: FieldConfig[];
//   initialValues: Record<string, string>;
//   fieldIdToParamName: Record<string, string>;
// } {
//   const fields: FieldConfig[] = [];
//   const initialValues: Record<string, string> = {};
//   const fieldIdToParamName: Record<string, string> = {};

//   if (!params || params.length === 0) {
//     return { fields, initialValues, fieldIdToParamName };
//   }

//   for (const p of params) {
//     const id = toSafeId(p.paramName);
//     const required =
//       typeof p.optional === "string"
//         ? p.optional.toLowerCase() === "false"
//         : !p.optional;

//     const validations: FieldValidations = {};
//     if (p.minLength) validations.minLength = Number(p.minLength);
//     if (p.maxLength) validations.maxLength = Number(p.maxLength);
//     const allowedChars = detectAllowedChars(p.dataType, p.regex);
//     if (allowedChars) validations.allowedChars = allowedChars;

//     if (p.regex) {
//       try {
//         validations.pattern = new RegExp(p.regex);
//         // validations.regex = new RegExp(p.regex);
//       } catch {
//         // agar kuch biller ka regex toot gaya to UI crash na ho
//       }
//     }

//     const field: FieldConfig = {
//       id,
//       label: p.paramName,
//       as: "input",
//       type: "text",
//       placeholder: p.paramName, // tumhari requirement
//       required,
//       validations,
//       meta: { billerParamName: p.paramName },
//     };

//     fields.push(field);
//     initialValues[id] = "";
//     fieldIdToParamName[id] = p.paramName;
//   }

//   return { fields, initialValues, fieldIdToParamName };
// }
